import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root'
})
export class RitwikReportService {

  constructor(private api: ApiService) { }

  getRitwikReport(fc: any): Observable<any>{
    return this.api.get(ROUTES.RITWIK_REPORT, {params: fc})
  }
}
